export const LISTENING_DISPLAY_UNITS = {
  SPL: "SPL",
  HL: "HL",
};

export const SPL_TO_HL_CORRECTION_DB = {
  500: 4.0,
  1000: 2.0,
  2000: -1.5,
  4000: -6.5,
  8000: 0,
  16000: 0,
};

export function hlToSpl(frequency, value) {
  const correction = SPL_TO_HL_CORRECTION_DB[Number(frequency)];
  const numericValue = Number(value);
  if (correction === undefined || !Number.isFinite(numericValue)) {
    return null;
  }
  return numericValue + correction;
}

export function splToHl(frequency, value) {
  const correction = SPL_TO_HL_CORRECTION_DB[Number(frequency)];
  const numericValue = Number(value);
  if (correction === undefined || !Number.isFinite(numericValue)) {
    return null;
  }
  return numericValue - correction;
}

export function convertSplForDisplay(frequency, value, displayUnit) {
  if (value === null || value === undefined || value === "") {
    return null;
  }
  if (displayUnit === LISTENING_DISPLAY_UNITS.SPL) {
    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? numericValue : null;
  }
  return splToHl(frequency, value);
}
